/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplatesControllerFindAllQueryResponse, TemplatesControllerFindAllQueryParams, TemplatesControllerFindAll401, TemplatesControllerFindAll403 } from "../../models/checklistsController/TemplatesControllerFindAll";

function getTemplatesControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/checklist-templates` as const }  
  return res
}

/**
 * @summary Get all checklist templates
 * {@link /api/v1/checklist-templates}
 */
export async function templatesControllerFindAll(params?: TemplatesControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplatesControllerFindAllQueryResponse, ResponseErrorConfig<TemplatesControllerFindAll401 | TemplatesControllerFindAll403>, unknown>({ method : "GET", url : getTemplatesControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}